/**
 * @generated SignedSource<<545ffd83019c8e621f44fd2421b23b2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubPageSearchFieldsEnum = "AuthorId" | "Content" | "Created" | "Description" | "FormId" | "Id" | "Modified" | "Status" | "StatusSettings" | "Title";
export type OrderEnum = "ASC" | "DESC";
export type PostObjectsConnectionDateColumnEnum = "DATE" | "MODIFIED";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type RelationEnum = "AND" | "OR";
export type RootQueryToHubPageConnectionWhereArgs = {
  authorId?: string | null | undefined;
  authorIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  authorIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  content?: string | null | undefined;
  createdDateQuery?: DateQueryInput | null | undefined;
  description?: string | null | undefined;
  formId?: string | null | undefined;
  formIdIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  formIdNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  id?: string | null | undefined;
  idIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  idNotIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  modifiedDateQuery?: DateQueryInput | null | undefined;
  order?: OrderEnum | null | undefined;
  orderBy?: ReadonlyArray<HubPageSearchFieldsEnum | null | undefined> | null | undefined;
  search?: string | null | undefined;
  searchFields?: ReadonlyArray<HubPageSearchFieldsEnum | null | undefined> | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  statusNotIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  title?: string | null | undefined;
};
export type DateQueryInput = {
  after?: DateInput | null | undefined;
  before?: DateInput | null | undefined;
  column?: PostObjectsConnectionDateColumnEnum | null | undefined;
  compare?: string | null | undefined;
  day?: number | null | undefined;
  hour?: number | null | undefined;
  inclusive?: boolean | null | undefined;
  minute?: number | null | undefined;
  month?: number | null | undefined;
  relation?: RelationEnum | null | undefined;
  second?: number | null | undefined;
  week?: number | null | undefined;
  year?: number | null | undefined;
};
export type DateInput = {
  day?: number | null | undefined;
  month?: number | null | undefined;
  year?: number | null | undefined;
};
export type HubPages_Pagination_Query$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  where?: RootQueryToHubPageConnectionWhereArgs | null | undefined;
};
export type HubPages_Pagination_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HubPages_Pagination_Fragment">;
};
export type HubPages_Pagination_Query = {
  response: HubPages_Pagination_Query$data;
  variables: HubPages_Pagination_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StateWhenApproved",
      "kind": "LinkedField",
      "name": "stateWhenApproved",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v8/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Form",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitSuccessText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingConsent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v14 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mediaItemUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mimeType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaDetails",
    "kind": "LinkedField",
    "name": "mediaDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubPages_Pagination_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "HubPages_Pagination_Fragment"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HubPages_Pagination_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToHubPageConnection",
        "kind": "LinkedField",
        "name": "hubPages",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToHubPageConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubPage",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NodeWizAuthorToUserConnectionEdge",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modified",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubPageToFormConnectionEdge",
                    "kind": "LinkedField",
                    "name": "form",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v13/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "order": "ASC",
                          "orderBy": "CatalogOrder"
                        }
                      }
                    ],
                    "concreteType": "HubPageToConnectionHpToCsConnection",
                    "kind": "LinkedField",
                    "name": "connectionHpToCs",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HubPageToConnectionHpToCsConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConnectionHpToC",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "catalogId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "catalogOrder",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConnectionHpToCToZnglyVideoConnectionEdge",
                                "kind": "LinkedField",
                                "name": "catalog",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ZnglyVideo",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "databaseId",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "link",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "date",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "trashDate",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "trashTimeUntil",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NodeWithAuthorToUserConnectionEdge",
                                        "kind": "LinkedField",
                                        "name": "author",
                                        "plural": false,
                                        "selections": (v11/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          (v13/*: any*/)
                                        ],
                                        "concreteType": "ZnglyVideoToCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "categories",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ZnglyVideoToCategoryConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Category",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v8/*: any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "categories(first:100)"
                                      },
                                      (v9/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ZnglyVideo_Znglycontent",
                                        "kind": "LinkedField",
                                        "name": "znglyContent",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aiSummary",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "contentEmbedHtml",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "contentMediaName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "contentMediaType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "contentLink",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MediaItem",
                                            "kind": "LinkedField",
                                            "name": "contentFile",
                                            "plural": false,
                                            "selections": (v14/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "MediaItem",
                                            "kind": "LinkedField",
                                            "name": "featuredImageFile",
                                            "plural": false,
                                            "selections": (v14/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "featuredImageLink",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "ctaLink",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "ctaName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
                                            "kind": "LinkedField",
                                            "name": "form",
                                            "plural": false,
                                            "selections": (v12/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "htmlDesc",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "shortText",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "connectionHpToCs(first:100,where:{\"order\":\"ASC\",\"orderBy\":\"CatalogOrder\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToHubPageConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "HubPages_Pagination_Fragment_Connection_hubPages",
        "kind": "LinkedHandle",
        "name": "hubPages"
      }
    ]
  },
  "params": {
    "cacheID": "d7f2d293c1da566f0a34b1d017bac9a5",
    "id": null,
    "metadata": {},
    "name": "HubPages_Pagination_Query",
    "operationKind": "query",
    "text": "query HubPages_Pagination_Query(\n  $after: String\n  $first: Int\n  $where: RootQueryToHubPageConnectionWhereArgs\n) {\n  ...HubPages_Pagination_Fragment_3sueo6\n}\n\nfragment HubPages_Pagination_Fragment_3sueo6 on RootQuery {\n  hubPages(first: $first, after: $after, where: $where) {\n    edges {\n      node {\n        id\n        __typename\n        title\n        description\n        status\n        statusSettings {\n          status\n          uiPermission {\n            type\n            token\n          }\n          stateWhenApproved {\n            status\n            uiPermission {\n              type\n              token\n            }\n          }\n          approved {\n            id\n            timestamp\n            user {\n              name\n              id\n            }\n          }\n        }\n        content\n        author {\n          node {\n            id\n            name\n            username\n            slug\n          }\n        }\n        created\n        modified\n        formId\n        form {\n          node {\n            id\n            title\n            content\n            schema\n            uiSchema\n            metadata {\n              formStyle\n              formTemplate\n              cookieExpiration\n              submitSuccessText\n            }\n            marketingConsent\n            password\n            imageUrl\n          }\n        }\n        connectionHpToCs(first: 100, where: {order: ASC, orderBy: CatalogOrder}) {\n          edges {\n            node {\n              catalogId\n              catalogOrder\n              catalog {\n                node {\n                  id\n                  databaseId\n                  title\n                  link\n                  date\n                  status\n                  trashDate\n                  trashTimeUntil\n                  author {\n                    node {\n                      id\n                      name\n                      username\n                      slug\n                    }\n                  }\n                  categories(first: 100) {\n                    edges {\n                      node {\n                        name\n                        id\n                      }\n                    }\n                  }\n                  statusSettings {\n                    status\n                    uiPermission {\n                      type\n                      token\n                    }\n                    stateWhenApproved {\n                      status\n                      uiPermission {\n                        type\n                        token\n                      }\n                    }\n                    approved {\n                      id\n                      timestamp\n                      user {\n                        name\n                        id\n                      }\n                    }\n                  }\n                  znglyContent {\n                    aiSummary\n                    contentEmbedHtml\n                    contentMediaName\n                    contentMediaType\n                    contentLink\n                    contentFile {\n                      id\n                      mediaItemUrl\n                      mimeType\n                      mediaDetails {\n                        sizes {\n                          sourceUrl\n                          name\n                        }\n                      }\n                      description\n                    }\n                    featuredImageFile {\n                      id\n                      mediaItemUrl\n                      mimeType\n                      mediaDetails {\n                        sizes {\n                          sourceUrl\n                          name\n                        }\n                      }\n                      description\n                    }\n                    featuredImageLink\n                    ctaLink\n                    ctaName\n                    form {\n                      node {\n                        id\n                        title\n                        content\n                        schema\n                        uiSchema\n                        metadata {\n                          formStyle\n                          formTemplate\n                          cookieExpiration\n                          submitSuccessText\n                        }\n                        marketingConsent\n                        password\n                        imageUrl\n                      }\n                    }\n                    htmlDesc\n                    shortText\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b5dce16eab0b436732f64237f325a44";

export default node;
